// Third Party Imports
import React from 'react';
import {get} from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';

// Relative Imports\
import AlertBox from '../Alert/Alert';
import ButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import SubHead from '../SubHead/SubHead';
import './styles.less';
import currencyActions from '../../actions/currency';
import appActions from '../../actions/actions';
import getCurrencySymbol from '../utils/currencyUtil';
import {DEEP_LINK_PARAM_TYPE, getDeepLinkParams} from '../../utils/localStorageDataHandler';

function mapStateToProps(state) {
    return {
        publicUuid: state.app.publicUuid,
        siteName: state.system.siteName,
        userType: get(state, 'app.userType', 'IPM'),
        translations: state.app.translations,
        errorKey: state.currency.errorKey,
        currencyList: state.currency.currencyList,
        currency: state.currency.currency ? state.currency.currency : '',
        userInfo: state.currency.userInfo ? state.currency.userInfo : '',
        brandName: state.system.brandName,
        currencyChangeError: state.currency.currencyChangeError,
        enableContinueButton: state.currency.enableContinueButton,
        currencyState: get(state, 'currency', {}),
        isSaveModalOpen: get(state, 'app.isSaveModalOpen', false)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        currencyActions: bindActionCreators(currencyActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Currency extends React.Component {
    constructor(props) {
        super(props);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleContinueClick = this.handleContinueClick.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleSaveAndFinishOnClick = this.handleSaveAndFinishOnClick.bind(this);
        this.prePopulateLocalState = this.prePopulateLocalState.bind(this);
        this.handleSaveModalClose = this.handleSaveModalClose.bind(this);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(true);
        this.props.currencyActions.getCurrencies();
        this.prePopulateLocalState();
    }

    componentDidMount() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Currency Page');
        this.setCurrencyByPmscParam();
    }

    setCurrencyByPmscParam() {
        const pmscParams = getDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams);
        if (pmscParams && pmscParams.currency) {
            this.props.currencyActions.setCurrency(pmscParams.currency);
            this.props.currencyActions.enableContinueButton(true);
        }
    }

    getListItems() {
        let {currencyList, translations} = this.props;
        let items = currencyList instanceof Array && currencyList.length > 0 ?
            currencyList.map((e) => ({
                label: `${getCurrencySymbol(e)} (${translations[`ipmob.currency.${e}`] ? translations[`ipmob.currency.${e}`] : e})`,
                value: e
            })) :
            [];
        items.unshift('');
        return items;
    }

    handleCurrencyChange(e) {
        const value = e.target.value;
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: 'Currency selected',
            eventaction: 'Currency selected',
            highfrequency: 'true'
        }, {});
        this.props.currencyActions.setCurrency(value);
        if (value.trim() === '') {
            this.props.currencyActions.setCurrencyChangeError('ipmob.input.field.required');
            this.props.currencyActions.enableContinueButton(false);
        } else {
            this.props.currencyActions.setCurrencyChangeError(null);
            this.props.currencyActions.enableContinueButton(true);
        }
    }

    handleContinueClick() {
        let {currencyList} = this.props;
        this.props.appActions.enableLoadOverLay(true);
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        if (currencyList instanceof Array && currencyList.length === 1) {
            this.props.currencyActions.updateCurrency(currencyList[0], this.props.userInfo);
        } else {
            this.props.currencyActions.updateCurrency(this.props.currency, this.props.userInfo);
        }
    }

    getHeading() {
        let {currencyList, translations} = this.props;
        return currencyList instanceof Array && currencyList.length === 1 ?
            translations['ipmob.currency.heading.2'] :
            translations['ipmob.currency.heading.1'];
    }

    renderCurrencyComponent() {
        let {currency, currencyList, translations, brandName, currencyChangeError} = this.props;
        return (currencyList instanceof Array && currencyList.length === 1)
            ? <div>
                <div className="currency-brand"><b>{`${brandName} ${translations['ipmob.currency.brand.currency']}:`}</b></div>
                <div className="currency-desc">{`${getCurrencySymbol(currencyList[0])} (${translations[`ipmob.currency.${currencyList[0]}`] ? translations[`ipmob.currency.${currencyList[0]}`] : currencyList[0]})`}</div>
            </div>
            : (
                <FormSelect
                    id="currency"
                    className="currency-select"
                    name={translations['ipmob.currency']}
                    items={this.getListItems()}
                    value={currency}
                    onChange={this.handleCurrencyChange}
                    label={translations['ipmob.currency']}
                    errorMsg={translations[currencyChangeError]}
                />
            );
    }

    handleAlertDismiss() {
        this.props.currencyActions.currencyServiceError('');
    }

    handleSaveAndFinishOnClick() {
        const stateData = this.props.currencyState;
        delete stateData.errorKey;
        this.props.appActions.saveComponentState('currency', stateData);
        this.props.appActions.showSaveAndFinishModal(true);
    }

    prePopulateLocalState() {
        this.props.currencyActions.prePopulateLocalState(this.props.publicUuid);
    }

    handleSaveModalClose() {
        this.props.appActions.showSaveAndFinishModal(false);
    }

    render() {
        let {
            translations,
            errorKey,
            enableContinueButton,
            isSaveModalOpen
        } = this.props;

        return (
            <div className="currency">
                <div className="currency-container">
                    <SubHead
                        translations={translations}
                        handleSaveAndFinishOnClick={this.handleSaveAndFinishOnClick}
                        isSaveModalOpen={isSaveModalOpen}
                        handleSaveModalClose={this.handleSaveModalClose}
                    />
                    {
                        (errorKey)
                            ? <div className="alert-panel">
                                <AlertBox
                                    messageKey={errorKey}
                                    translations={translations}
                                    handleAlertDismiss={this.handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                            : null
                    }
                    <div className="currency-wrapper">
                        <div className="currency-content-col">
                            <div>
                                <h2 className="currency-heading"> {this.getHeading()} </h2>
                                <h3 className="currency-sub-heading"> {translations['ipmob.currency.heading.4']} </h3>
                                <div className="currency-desc"> {translations['ipmob.currency.sub.heading']} </div>
                                {errorKey ? null : this.renderCurrencyComponent()}
                            </div>
                        </div>
                    </div>
                    <ButtonHolder translations={translations} enableContinueButton={enableContinueButton} handleContinueButtonClick={this.handleContinueClick} continueButtonId={'currencyPageContnBtn'}/>
                </div>
            </div>
        );
    }
}
